var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AppNotification',{attrs:{"title":_vm.notification.title,"description":_vm.description,"level":_vm.level,"detailUrl":_vm.detailUrl},on:{"close":_vm.close}})
}
var staticRenderFns = []

export { render, staticRenderFns }